import store from '@/modules/store'
import Vue from 'vue'
import { EventBus } from '@/modules/plugins/modules/event'

Vue.prototype.$maxXS = 575

Vue.prototype.$minSM = 576
Vue.prototype.$maxSM = 767

Vue.prototype.$minMD = 768
Vue.prototype.$maxMD = 991

Vue.prototype.$minLG = 992
Vue.prototype.$maxLG = 1279

Vue.prototype.$minXL = 1280
Vue.prototype.$maxXL = 1599

Vue.prototype.$minXXL = 1600
Vue.prototype.$maxXXL = 2199

Vue.prototype.$minXXXL = 2200

Vue.prototype.smallDeviceSize = ['xs', 'sm', 'md'] // => _device-view.scss

const checkXS = window.matchMedia(`(max-width: ${Vue.prototype.$maxXS}px)`)

const checkSM = window.matchMedia(
    `(min-width: ${Vue.prototype.$minSM}px) and (max-width: ${Vue.prototype.$maxSM}px)`
)
const checkMD = window.matchMedia(
    `(min-width: ${Vue.prototype.$minMD}px) and (max-width: ${Vue.prototype.$maxMD}px)`
)
const checkLG = window.matchMedia(
    `(min-width: ${Vue.prototype.$minLG}px) and (max-width: ${Vue.prototype.$maxLG}px)`
)
const checkXL = window.matchMedia(
    `(min-width: ${Vue.prototype.$minXL}px) and (max-width: ${Vue.prototype.$maxXL}px)`
)
const checkXXL = window.matchMedia(
    `(min-width: ${Vue.prototype.$minXXL}px) and (max-width: ${Vue.prototype.$maxXXL}px)`
)
const checkXXXL = window.matchMedia(`(min-width: ${Vue.prototype.$minXXXL}px)`)

checkXS.size = 'xs'
checkSM.size = 'sm'
checkMD.size = 'md'
checkLG.size = 'lg'
checkXL.size = 'xl'
checkXXL.size = 'xxl'
checkXXXL.size = 'xxxl'

function isMobileDevice() {
    return window.matchMedia('(any-pointer:coarse)').matches
}

function initSize(width) {
    let size = 'xs'
    if (Vue.prototype.$maxXS < width) size = 'sm'
    if (Vue.prototype.$maxSM < width) size = 'md'
    if (Vue.prototype.$maxMD < width) size = 'lg'
    if (Vue.prototype.$maxLG < width) size = 'xl'
    if (Vue.prototype.$maxXL < width) size = 'xxl'
    if (Vue.prototype.$maxXXL < width) size = 'xxxl'
    store.dispatch('setSize', size)
}

async function mediaChanged(e) {
    if (e.matches) {
        const sizeValueBefore = store.getters['smDevice']
        await store.dispatch('setSize', e.srcElement.size)
        await store.dispatch('setMobileDevice', isMobileDevice())
        EventBus.$emit('deviceSizeChange', e.srcElement.size)
        if (sizeValueBefore !== store.getters['smDevice'])
            EventBus.$emit('deviceTypeChange', {
                smDevice: store.getters['smDevice'],
                lgDevice: !store.getters['smDevice'],
            })
    }
}

checkXS.addEventListener('change', mediaChanged)
checkSM.addEventListener('change', mediaChanged)
checkMD.addEventListener('change', mediaChanged)
checkLG.addEventListener('change', mediaChanged)
checkXL.addEventListener('change', mediaChanged)
checkXXL.addEventListener('change', mediaChanged)
checkXXXL.addEventListener('change', mediaChanged)

initSize(window.innerWidth)
store.dispatch('setMobileDevice', isMobileDevice())
store.dispatch(
    'isApple',
    ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(
        navigator.platform
    ) ||
        (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
)
